// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import ParamsModal from './ParamsModal';

// Import Material UI
import { IconButton } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

// Import CSS
import './table.css';

export default function Table({ action, options, inputName, isRequired, setOpenVariable, formData, automId, headerWithVariable, variables }) {
    const [open, setOpen] = useState({ show: false, index: -1 })
    const [isControl, setIsControl] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        let y = Object.keys(action.fields)
        if (y.indexOf(inputName) === -1) {
            if (inputName !== undefined) {
                action.fields[inputName] = {};
                let x = Object.keys(action.fields[inputName])
                if (x.indexOf(inputName) === -1) {
                    action.fields[inputName] = { type: "ARRAY", value: [], isRequired };
                }
            }
        }

    }, [action])

    useEffect(() => {
        let y = Object.keys(action.fields)
        setIsControl(y);
    }, [inputName])

    const handleAddButton = () => {
        setOpen({ show: true, index: -1, actionType: 'create' })
    }

    const handleUpdateButton = (index) => {
        setOpen({ show: true, index, actionType: 'update' });
    }

    return (
        <div className='data-table-container-area'>
            <div className='table-area'>
                <IconButton className='add-column-icon-button' onClick={handleAddButton}>
                    <AddCircleOutlineIcon className="add-column-icon" />
                </IconButton>
                <table className="table">
                    <thead>
                        <tr>
                            {options?.headers?.map((item, itemI) =>
                                <th key={itemI}>{t(item)}</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {(action.fields !== undefined && isControl.indexOf(inputName) !== -1 && Array.isArray(action.fields[inputName]?.value)) && action.fields[inputName].value.map((item, index) => (
                            <tr key={index} className={index % 2 === 0 ? 'active-row' : ''}>
                                <td> {item.columnSelector}</td>
                                <td> {item.column}</td>
                                <CreateIcon onClick={() => handleUpdateButton(index)} className='create-column-icon' />
                            </tr>
                        ))}
                    </tbody>
                </table>
                {open?.show && (
                    <ParamsModal
                        action={action} title={t(options?.title)}
                        customFields={options.customFields}
                        variables={variables}
                        setOpen={setOpen}
                        setOpenVariable={setOpenVariable}
                        inputName={inputName}
                        formData={formData}
                        automId={automId}
                        headerWithVariable={headerWithVariable}
                        index={open.index}
                        actionType={open.actionType}
                    />
                )}
            </div>
        </div>
    );
}